import axios from 'axios'

axios.defaults.headers['Content-Type'] = 'application/json'

export default {
  getProducts({
    language, skip, take, page, activeCategories = [], terms = [], sorting = null
  }) {
    const params = {
      skip,
      take,
      page,
      sorting,
      terms: encodeURIComponent(terms.join('|')),
      categories: encodeURIComponent(activeCategories.map((category) => category.uid).join('|'))
    }
    return axios.get(`/${language}/api/search/products`, { params })
  },
  getSearchItems({
    take,
    page,
    searchType,
    searchTypes = [],
    activeCategories = [],
    terms = [],
    sorting = null,
    language = null
  }, { skip }) {
    const params = {
      skip,
      take,
      page,
      sorting,
      searchType,
      searchtypes: searchTypes.join('|'),
      terms: encodeURIComponent(terms.join('|')),
      categories: encodeURIComponent(activeCategories.map((category) => category.uid).join('|')),
      language
    }
    return axios.get(`/${language}/api/search/searchitems`, { params })
  },
  getAutoSuggestions(query, language, searchType) {
    const params = {
      query: encodeURIComponent(query),
      language,
      searchType
    }
    return axios.get(`/${language}/api/search/autosuggestion`, { params })
  },
  trackItemClick(params) {
    axios.get('/api/search/trackitemclick', { params })
  },
  trackAutoSuggestionClick(params) {
    axios.get('/api/search/trackautosuggestionclick', { params })
  },
  createCancelToken() {
    return axios.CancelToken.source()
  }
}
